import { render } from "./PrincipalMenu.vue?vue&type=template&id=6709c4ca&scoped=true&ts=true"
import script from "./PrincipalMenu.vue?vue&type=script&lang=ts"
export * from "./PrincipalMenu.vue?vue&type=script&lang=ts"

import "./PrincipalMenu.vue?vue&type=style&index=0&id=6709c4ca&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6709c4ca"]])

export default __exports__